import {useAuth} from "@/auth/useAuth";
import {asyncStoragePersister} from "@/data/app-data-persister";
import {unregisterPushDevice} from "@/lib/push-notifications";

export const useLogout = () => {
    const {interalLogout: pbLogout} = useAuth();

    const logout = async () => {
        try {
            // Must run before pbLogout: the unregister call is authenticated, and once the
            // PocketBase auth store is cleared it can only 401. Caught separately so that being
            // unable to release the push token never traps the user in a logged-in state — a
            // stale device row costs one wasted push, a failed logout costs the user the app.
            try {
                await unregisterPushDevice();
            } catch (error) {
                console.warn('Push unregister failed, continuing logout:', error);
            }

            // Clear PocketBase auth AND all query caches (in memory + persisted)
            await pbLogout();

            // Additional safety: ensure persisted cache is removed
            await asyncStoragePersister.removeClient();
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    return { logout };
};
